import React from "react";

const Java_Double = () => {
  return (
    <div>
      <h1>Java Double</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Double in Java.</p>
    </div>
  );
};

export default Java_Double;
